import StringHelper from './StringHelper';

const FIRST_SEMESTER_START_MONTH = 8, SECOND_SEMESTER_START_MONTH = 2;
const FIRST_SEMESTER_START_DAY = 1, SECOND_SEMESTER_START_DAY = 1;

export default class SharedTools {
  constructor() {
  }

  static cloneObject(oldObject) {
    return JSON.parse(JSON.stringify(oldObject));
  }

  static get firstSemesterStartMonth() {
    return FIRST_SEMESTER_START_MONTH;
  }

  static get firstSemesterStartDay() {
    return FIRST_SEMESTER_START_DAY;
  }

  static get secondSemesterStartMonth() {
    return SECOND_SEMESTER_START_MONTH;
  }

  static get secondSemesterStartDay() {
    return SECOND_SEMESTER_START_DAY;
  }

  // return 20151, 20162 or 20141 etc.
  // 20151 means the first semester of Year 2015
  // 20162 means the second semester of Year 2016
  static getCurrentSemester(time) {
    const generateSemester = (year, semesterIndex) => {
      return year * 10 + semesterIndex;
    }

    let today = time ? new Date(time) : new Date();
    let year = today.getFullYear();
    let first_semester_start = new Date(year, SharedTools.firstSemesterStartMonth - 1, SharedTools.firstSemesterStartDay);
    let second_semester_start = new Date(year, SharedTools.secondSemesterStartMonth - 1, SharedTools.secondSemesterStartDay);

    return today >= first_semester_start ? generateSemester(year, 1) : (today >= second_semester_start ? generateSemester(year - 1, 2) : generateSemester(year - 1, 1));
  }

  static getArrayByRange(begin, end, interval = 1) {
    let result = [];
    for (let i = begin; i <= end; i += interval) {
      result.push(i);
    }
    return result;
  }

  static getPreviousSemester(currentSemester) {
    if (!currentSemester)
      return currentSemester

    let year = currentSemester.toString().substring(0, 4);
    let semester = currentSemester.toString().substring(4, 5);

    if (semester == '1') {
      return ((Number(year) - 1) + (Number(semester) + 1).toString())
    } else {
      return (year + (Number(semester) - 1))
    }
  }

  static getNextSemester(currentSemester) {
    let year = currentSemester.toString().substring(0, 4);
    let semester = currentSemester.toString().substring(4, 5);

    if (semester == '2') {
      return Number((Number(year) + 1) + (Number(semester) - 1).toString())
    } else {
      return Number(year + (Number(semester) + 1))
    }
  }

  // 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ===> 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11
  static getPreviousMonth(month) {
    return (month - 13) % 12 + 12;
  }

  static getSemesterArray(graderNumber) {
    let semester = String(SharedTools.getCurrentSemester());
    let number = semester.toString().split('')[4];
    let semesterArray = [];
    let n;
    switch (graderNumber) {
      case 7:
        n = 0;
        break;
      case 8:
        n = 2;
        break;
      case 9:
        n = 4;
        break;
    }
    if (number == '2') {
      n++
    }
    for (let i = n; i >= 0; i--) {
      if (i <= 1) {
        graderNumber = 7;
      } else if (i > 1 && i < 4) {
        graderNumber = 8;
      } else {
        graderNumber = 9;
      }
      let semesterToString = StringHelper.semesterToString(graderNumber, semester)
      semesterArray.push({semester, semesterToString})
      semester = SharedTools.getPreviousSemester(semester);
    }

    return semesterArray;
  }

  static getSemesterToString(semester, graderNumber) {
    let currentSemester = SharedTools.getCurrentSemester();
    let currentYear = currentSemester.toString().slice(0, 4);
    let year = semester.toString().slice(0, 4);
    graderNumber = graderNumber - (Number(currentYear) - Number(year));
    return StringHelper.semesterToString(graderNumber, semester);
  }

  static getYearSemesterArray() {
    let semester = String(SharedTools.getCurrentSemester());
    let yearSemesterArray = [];

    for (let i = 0; i < 6; i++) {
      let year = semester.substring(0, 4);
      let number = semester.substring(4, 5);
      let semesterToString;
      if (number == '2') {
        semesterToString = String(Number(year) + 1) + `.${SharedTools.secondSemesterStartMonth} - ` + String(Number(year) + 1) + `.${SharedTools.getPreviousMonth(SharedTools.firstSemesterStartMonth)}`;
      } else if (number == '1'){
        semesterToString = String(year) + `.${SharedTools.firstSemesterStartMonth} - ` + String(Number(year) + 1) + `.${SharedTools.getPreviousMonth(SharedTools.secondSemesterStartMonth)}`;
      }
      yearSemesterArray.push({semester: semester, semesterToString: semesterToString});
      semester = SharedTools.getPreviousSemester(semester);
    }

    return yearSemesterArray;
  }

  static getYearSemestertoString(startTime, expireTime) {
    let time1 = new Date(StringHelper.toDate(startTime));
    let time2 = new Date(StringHelper.toDate(expireTime));

    let year1 = time1.getFullYear();
    let year2 = time2.getFullYear();

    let month1 = time1.getMonth();
    let month2 = time2.getMonth();
    let semesterToString;

    if (month1 >= SharedTools.secondSemesterStartMonth && month2 < SharedTools.firstSemesterStartMonth && year1 == year2) {
      semesterToString = year1 + `.${SharedTools.secondSemesterStartMonth} - ` + year2 + `.${SharedTools.getPreviousMonth(SharedTools.firstSemesterStartMonth)}`;
    }
    else if (month1 >= SharedTools.firstSemesterStartMonth && month2 < SharedTools.secondSemesterStartMonth  && (Number(year1) == Number(year2) - 1)) {
      semesterToString = year1 + `.${SharedTools.firstSemesterStartMonth} - ` + year2 + `.${SharedTools.getPreviousMonth(SharedTools.secondSemesterStartMonth)}`;
    }
    return semesterToString;
  }

  static getThumbImageUrl(originalUrl) {
    return (originalUrl.match(/\?imgeView2/) || originalUrl.match(/\?imageMogr2/)) ? originalUrl : `${originalUrl}?imageView2/1/w/150/h/150`;
  }

  static getMediumImageUrl(originalUrl) {
    return (originalUrl.match(/\?imgeView2/) || originalUrl.match(/\?imageMogr2/)) ? originalUrl : `${originalUrl}?imageView2/0/w/338`;
  }

  static formatNumber(n) {
    n = n.toString();
    return n[1] ? n : ('0' + n);
  }

  static strToDate(dateObj) {
    dateObj = dateObj.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '/');
    dateObj = dateObj.slice(0, dateObj.indexOf("."));
    return new Date(dateObj);
  }

  static addRoleName (role, name) {
    if (role == 'teacher' || role == 'Teacher') {
      if (/^[\u4E00-\u9FA5]+$/.test(name)) { //全中文
        let nameList = ['欧阳', '太史', '端木', '上官', '司马', '东方', '独孤', '南宫', '万俟', '闻人', '夏侯', '诸葛', '尉迟', '公羊', '赫连', '澹台', '皇甫', '宗政', '濮阳', '公冶', '太叔', '申屠', '公孙', '慕容', '仲孙', '钟离', '长孙', '宇文', '司徒', '鲜于', '司空', '闾丘', '子车', '亓官', '司寇', '巫马', '公西', '颛孙', '壤驷', '公良', '漆雕', '乐正', '宰父', '谷梁', '拓跋', '夹谷', '轩辕', '令狐', '段干', '百里', '呼延', '东郭', '南门', '羊舌', '微生', '公户', '公玉', '公仪', '梁丘', '公仲', '公上', '公门', '公山', '公坚', '左丘', '公伯', '西门', '公祖', '第五', '公乘', '贯丘', '公皙', '南荣', '东里', '东宫', '仲长', '子书', '子桑', '即墨', '达奚', '褚师', '吴铭'];  //现存的复姓

        name = name.replace("老师","");
        let familyname = name.substr(0, 1);
        let familySurname = name.substr(0, 2);

        name = familyname + "老师";
        nameList.forEach((surname) => {
          if (familySurname == surname) {
            name = familySurname + "老师";
          }
        })

        if (familyname == '小' && familySurname.length > 1) {
          name = familySurname + "老师";
        }
      } else {
        name = (name.indexOf('老师') == -1) ? name + "老师" : name;
      }
    } else if (role == 'parent' || role == 'Parent') {
      name = (name.indexOf('家长') == -1) ? name + "家长" : name;
    }
    return name;
  }

  static getStudentSemesters(gradeNumber) {
    let grades = ['托班', '小班', '中班', '大班', '大大班'], currentSemester = SharedTools.getCurrentSemester(), result = new Array();
    let semesters = SharedTools.getAllSemesters(SharedTools.getCurrentSemester(), 20171);
    semesters.forEach(({semester,semesterToString}, index) => {
      let newGrade = Number(gradeNumber) - (Number(currentSemester.toString().substring(0, 4)) - Number(semester.toString().substring(0, 4)));
      if (newGrade >= 1) {
        result.push({semester: semester, semesterToString: semesterToString});
      }
    })

    return result;

  }

  static formatDate(year, month) {
      var moreDaysArray = [1, 3, 5, 7, 8, 10, 12];
      var days = 0;
      if (moreDaysArray.indexOf(month) >= 0) {
        days = 31;
      } else if (month == 2) {
        if ((year % 100 == 0 && year % 400 == 0) || (year % 100 != 0 && year % 4 == 0)) {
          days = 29;
        } else {
          days = 28;
        }
      }  else {
        days = 30;
      }
      return days
  }

  static monthToString(month) {
    var monthArray = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'];
    return monthArray[month - 1];
  }

  static getAllSemesters(currentSemester, createSemester, archive_semester_count = 2, semesters = []) {
    let year = String(currentSemester).substring(0, 4);
    let number = String(currentSemester).substring(4, 5);
    let yearSub = Number(String(year).substring(2, 4));
    let semesterToString = '';

    if (archive_semester_count == 1) {
      semesterToString = yearSub + '-' + (yearSub + 1) + '学年';
    } else {
      semesterToString = (number == '1' ? yearSub + '-' + (yearSub + 1) + '学年上学期' : yearSub + '-' + (yearSub + 1) + '学年下学期');
    }

    if (currentSemester == createSemester) {
      if ((archive_semester_count == 1 && number == '1') || (archive_semester_count == 2)) {
        semesters.push({ semester: currentSemester, semesterToString });
      } else {
        semesters.push({ semester: year + '1', semesterToString });
      }
    } else {
      if ((archive_semester_count == 1 && number == '1') || (archive_semester_count == 2)) {
        semesters.push({ semester: currentSemester, semesterToString });
      }
      if (number == '2') {
        let semester = Number(year + '1')
        SharedTools.getAllSemesters(semester, createSemester, archive_semester_count, semesters);
      } else {
        let semester = Number(Number(year - 1) + '2')
        SharedTools.getAllSemesters(semester, createSemester, archive_semester_count, semesters);
      }
    }

    return semesters
  }
}



// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/lib/SharedTools.js